export default __webpack_public_path__ + "static/media/Team@2x.88d46a2d.png";